module.exports = __webpack_public_path__ + "static/media/attack-number-0.992a33e5.png";